import { createMutableAction } from '@bimser/core';
import * as ActionTypes from './actionTypes';
import { IChangeModalDataPayload } from '../entities';

export const changeModalDataAction = (data: IChangeModalDataPayload) =>
	createMutableAction(ActionTypes.CHANGE_MODAL_DATA, data);
